var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg65(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 1C11.074 1 1 11.074 1 23.5S11.075 46 23.5 46 46 35.929 46 23.5C46 11.072 35.927 1 23.5 1Z",
    fill: "#53AE94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.723 20.502v-3.347H13.07v-5.1h20.842v5.1h-7.655v3.344c6.221.286 10.9 1.518 10.9 2.994 0 1.476-4.68 2.708-10.9 2.996V37.21h-5.535V26.488c-6.21-.287-10.878-1.518-10.878-2.992 0-1.475 4.668-2.706 10.878-2.993h.002Zm-.002 5.078v-.003c.156.01.959.058 2.745.058 1.429 0 2.433-.04 2.788-.059v.005c5.496-.244 9.598-1.2 9.598-2.346 0-1.145-4.103-2.101-9.598-2.345v3.737c-.36.025-1.39.086-2.811.086-1.707 0-2.565-.071-2.723-.086V20.89c-5.485.244-9.578 1.202-9.578 2.344 0 1.14 4.095 2.1 9.578 2.344",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg65);
export default __webpack_public_path__ + "static/media/65.11bda85e37bbca919a9d2f104e933383.svg";
export { ForwardRef as ReactComponent };